import {Injectable} from '@angular/core';
import {DataService} from '../../services/data.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {Budget} from '../../interfaces';
import {take} from 'rxjs/operators';



@Injectable()
export class MergedBudgetListService {

    private budgetsSubject = new BehaviorSubject<Budget[]>([]);
    public budgets$: Observable<Budget[]> = this.budgetsSubject.asObservable();

    private isLoadingSubject = new BehaviorSubject<boolean>(true);
    public isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();

    constructor(private dataService: DataService) {
        this.loadBudgets();
    }

    private loadBudgets() {
        this.isLoadingSubject.next(true);
        this.dataService.getDeletedBudgets()
            .pipe(take(1))
            .subscribe(budgets => {
                this.budgetsSubject.next(budgets);
                this.isLoadingSubject.next(false);
            });
    }
}